"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = { class: "settings-item" };
const _hoisted_3 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_4 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_5 = { class: "settings-input oplus-form-switch" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    key: 1,
    class: "settings-card-container"
};
const _hoisted_8 = { class: "settings-item" };
const _hoisted_9 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_10 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_11 = { class: "settings-input oplus-form-switch" };
const _hoisted_12 = ["href"];
const _hoisted_13 = {
    key: 2,
    class: "settings-submit-button-wrapper"
};
const vue_3 = require("vue");
const common_1 = require("../../common/common");
const group_1 = require("../../requests/group");
const settings_1 = require("../../js/settings");
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsOthersContent',
    props: {
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        userId: {
            type: String,
            required: true,
        },
        group: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const useMFA = (0, vue_3.ref)(props.group.getGroupSettings().getUseMFA());
        const savedSettings = (0, vue_3.ref)('');
        const isLoading = (0, vue_3.ref)(false);
        const loadingClass = (0, vue_3.computed)(() => ({
            loading: isLoading.value,
        }));
        const localSettings = (0, vue_3.computed)(() => ({
            useMFA: useMFA.value,
        }));
        function getCurrentSettingsData() {
            return JSON.stringify(localSettings.value);
        }
        function hasUnsavedChanges() {
            return getCurrentSettingsData() !== savedSettings.value;
        }
        async function saveSettings() {
            if (isLoading.value) {
                return false;
            }
            isLoading.value = true;
            try {
                await (0, group_1.updateGroup)(props.userId, {
                    id: props.group.getId(),
                    name: props.group.getGroupName(),
                    address: props.group.getGroupAddress(),
                    useMFA: useMFA.value,
                });
                props.group.getGroupSettings().setUseMFA(useMFA.value);
                savedSettings.value = getCurrentSettingsData();
                (0, common_1.showSaveSuccessSnackbar)();
                return true;
            }
            catch (err) {
                (0, settings_1.importAlertModal)().alert(err);
                return false;
            }
            finally {
                isLoading.value = false;
            }
        }
        __expose({
            hasUnsavedChanges,
            saveSettings,
        });
        (0, vue_3.onMounted)(() => {
            savedSettings.value = getCurrentSettingsData();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createCommentVNode)(" Login "),
                (__props.isDefaultSettingsPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(["settings-card-container", { loading: isLoading.value }])
                    }, [
                        _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
                            (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "ログイン")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createCommentVNode)(" MFA "),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "多要素認証（MFA）", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "多要素認証を有効にする")
                                    ], -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_5, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((useMFA).value = $event)),
                                    type: "checkbox",
                                    disabled: isLoading.value
                                }, null, 8 /* PROPS */, _hoisted_6), [
                                    [vue_2.vModelCheckbox, useMFA.value]
                                ]),
                                _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                            ])
                        ])
                    ], 2 /* CLASS */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.isDefaultSettingsPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                        _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
                            (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "退会")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createCommentVNode)(" apiRemoveExisting "),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "退会手続き", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフトや従業員情報を含むすべてのデータが削除されます。")
                                    ], -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_11, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: `/dashboard/${__props.userId}/deactivate`,
                                    class: "oplus-btn oplus-btn-error-alt"
                                }, "退会", 8 /* PROPS */, _hoisted_12)
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.isDefaultSettingsPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                            onClick: saveSettings
                        }, "保存", 2 /* CLASS */)
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
